import template from './distance-unit.html';

const DIRECTIVE_NAME = DistanceUnit.DIRECTIVE_NAME = 'ktDistanceUnit';
export default function DistanceUnit() {
    return {
        restrict: 'AE',
        template,
        bindToController: true,
        controller: DistanceUnitController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            toLongForm: `=${DIRECTIVE_NAME}ToLongForm`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function DistanceUnitController(
    userService
) {
    'ngInject';

    const vm = this;
    const MILES_CODE = 'mi';
    const MILES_VALUE = 'miles';
    const KILOMETRES_VALUE = 'km';


    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        prepareDistanceUnit();
    }

    function prepareDistanceUnit() {
        const distanceUnit = userService.getRegionalSettings().distanceUnit;

        vm.distance = vm.toLongForm ? convertToLongForm() : distanceUnit;

        function convertToLongForm() {
            if (distanceUnit === MILES_CODE) {
                return MILES_VALUE;
            }
            return vm.distance = KILOMETRES_VALUE;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/distance-unit/distance-unit-component.js